module.exports = __webpack_public_path__ + "/10dba709647d78338c9b2dfb17a920c4.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/drop_signature_icon.svg
 ** module id = 1658
 ** module chunks = 0
 **/